import { ChangeDetectionStrategy, Component, computed, ElementRef, input } from '@angular/core';

import { tokenToCssVar } from '@core/utils-legacy';

import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';
import { BackgroundColors } from '../icon-container/icon-container.component';

@Component({
  selector: 'rt-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.link-disabled]': 'linksDisabled()',
    '[class.has-no-bottom-padding]': 'hasNoBottomPadding()',
    '[class.has-hover-state]': 'hasHoverState()',
    '[class.connected-on-bottom]': 'connectedOnBottom()',
    '[class.connected-on-top]': 'connectedOnTop()',
    '[class]': 'variant()',
    '[style.--bg-hover-color]': 'backgroundCssVar()',
  },
  standalone: true,
})
export class BoxComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'raised-higher',
      'no-radius',
      'background',
      'background-light',
      'background-light-blue',
      'border-light',
      'clickable',
      'no-padding',
      'padding-small',
      'horizontal',
      'vertical',
      'no-radius',
      'no-background',
      'no-border',
      'border-top',
      'no-border-bottom',
    ],
  ];

  public readonly variant = input(...ComponentVariantTransform(BoxComponent.VARIANTS));
  public readonly linksDisabled = input<boolean>(false);
  public readonly hasNoBottomPadding = input<boolean>(false);
  public readonly hasHoverState = input<boolean>(false);
  public readonly hoverBackgroundColor = input<BackgroundColors>('colorBgPrimarySubduedHover');
  public readonly connectedOnTop = input<boolean>(false);
  public readonly connectedOnBottom = input<boolean>(false);

  public backgroundCssVar = computed(() => tokenToCssVar(this.hoverBackgroundColor()));

  constructor(public elRef: ElementRef) {}
}
